import React from 'react'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import FieldValuesFormSection from '../../../../../../containers/fieldValues/form/FieldValuesFormSection'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'

const FieldsSection = () => {
  const { form } = useFormState()
  const placeType = form?.conditions?.find(cnd => {
    return cnd.field === 'place.place_type_id'
  })
  return (
    <>
      <Separator weight={2} />
      <FieldValuesFormSection //
        origin={placeType.value.key}
        path={['payload', 'field_values']}
        isPropSnakeCase
      />
    </>
  )
}

export default FieldsSection
